import Layout from '../app/Layout/Layout';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import routes from './routes';

function Router(): JSX.Element {
  const Root = <Layout />;
  //return (
  // <BrowserRouter basename={'/visionlab'}>
  //    <Switch>
  //      <Route exact path={['/'].concat(routes.map(route => route.path))}>
  //        {Root}
  //      </Route>
  //      <Route>
  //       <Redirect to={'/'} />
  //     </Route>
  //    </Switch>
  //  </BrowserRouter>
  //);
  return (
    <BrowserRouter basename={'/'}>
      <Switch>
        <Route exact path={['/'].concat(routes.map(route => route.path))}>
          {Root}
        </Route>
        <Route>
          <Redirect to={'/'} />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}

export default Router;
